module.exports = __webpack_public_path__ + "img/TapTap_Logo.98728523.png";